import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Alert, Card, CardBody, Col, Container, Row, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { SOURCES, campaignBadge, fmtDate, readError } from "../../helpers/whatsappTemplates";

const pct = (a, b) => (b > 0 ? `${Math.round((100 * a) / b)} %` : "—");
const eur = (v) => `${(v || 0).toFixed(2).replace(".", ",")} €`;
const kpi = { background: "#fff", borderRadius: 14, padding: "14px 16px", boxShadow: "0 0 0 1px rgba(0,0,0,.05)", height: "100%" };

// Résultats d'une campagne WhatsApp : remise, lecture, clics, ventes, désinscriptions, ventilation par source.
export function CampaignResults() {
    const { id } = useParams();
    const [r, setR] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        apiFetch(API.back + `/whatsapp-campaign-results?id=${id}`, { market: false })
            .then(async (res) => { if (!res.ok) throw new Error(await readError(res)); return res.json(); })
            .then(setR)
            .catch((e) => setError(e.message));
    }, [id]);

    if (error) return <Alert color="danger">{error}</Alert>;
    if (!r) return <Spinner size="sm" />;
    const c = r.campaign;
    const b = campaignBadge(c.status);
    const tiles = [
        ["Envoyés", r.sent, `${c.skippedCap || 0} au plafond, ${r.failed} échec(s)`],
        ["Remis", r.delivered, pct(r.delivered, r.sent)],
        ["Lus", r.read, pct(r.read, r.sent)],
        ["Clics", r.clicks, `${pct(r.clicks, r.sent)} des envoyés`],
        ["Ventes", r.sales, `${eur(r.commission)} de commission`],
        ["Désinscriptions", r.optedOut, `${pct(r.optedOut, r.sent)}${r.sent > 0 && r.optedOut / r.sent > 0.02 ? " — à surveiller" : " — note qualité ✓"}`],
    ];
    const sources = Object.entries(r.bySource || {}).filter(([k]) => k !== "" || Object.keys(r.bySource).length === 1);
    return (
        <Container fluid className="p-0">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1 className="h3 mb-0">{c.name}</h1>
                    <div className="text-muted small">{c.templateName} · envoi {fmtDate(c.startedAt || c.scheduledAt)} ·{" "}
                        <span style={{ padding: "2px 8px", borderRadius: 999, fontWeight: 700, background: b.bg, color: b.color }}>{b.label}</span></div>
                </div>
                <Link to={`/whatsapp/campaign/${c.id}`} className="btn btn-light">Voir la campagne</Link>
            </div>
            {c.failReason && <Alert color="danger">{c.failReason}</Alert>}
            <Row className="mb-3">
                {tiles.map(([l, v, s]) => <Col key={l} md="4" lg="2" className="mb-2"><div style={kpi}><div className="small text-muted">{l}</div><div style={{ fontSize: 24, fontWeight: 800 }}>{v}</div><div className="small text-muted">{s}</div></div></Col>)}
            </Row>
            {sources.length > 0 && <Card><CardBody className="p-0">
                <Table className="mb-0">
                    <thead><tr><th>Produit choisi d'après</th><th>Envoyés</th><th>Lus</th><th>Échecs</th><th>Taux de lecture</th></tr></thead>
                    <tbody>{sources.map(([k, s]) => <tr key={k}><td>{SOURCES[k] || k}</td><td>{s.sent}</td><td>{s.read}</td><td>{s.failed}</td><td>{pct(s.read, s.sent)}</td></tr>)}</tbody>
                </Table>
            </CardBody></Card>}
            {(r.topProducts || []).length > 0 && <Card><CardBody>
                <h5 className="mb-2">Produits les plus envoyés</h5>
                <div className="small">{r.topProducts.map((p) => `${p.slug} — ${p.count}`).join(" · ")}</div>
            </CardBody></Card>}
            <div className="small text-muted">Clics : visiteurs distincts arrivés sur le site depuis le message. Ventes : achats attribués au code de la campagne (jusqu'à 90 jours après le clic).</div>
        </Container>
    );
}
